import request from "@/CommonDP/utils/request";
import { viewOfficeUrl } from "@/CommonDP/utils";
import { isDef } from "@/CommonDP/utils/common";
import globalParams from "@/CommonDP/utils/globalParams";
import qs from "qs";

export default {
  queryPrj(keyword, enterpriseId) {
    return request.get(
      `/project/getProjectsByUserId?keyword=${keyword}&enterpriseId=${enterpriseId}`
    );
  },
  // 获得项目列表-分页
  getProjectsByUserIdWithPage(params) {
    return request.get("/project/getProjectsByUserIdWithPage", { params });
  },
  // 获得项目访问记录
  getUserVisitHistory(params) {
    return request.get("/pubUserVisitHistory/prj/list", { params });
  },
  // 保存项目访问记录
  savePubUserVisit(params) {
    return request.post("/pubUserVisitHistory/savePubUserVisit", params);
  },

  queryShareId(shareId) {
    return request
      .get(`/doc/queryShareById?shareId=${shareId}`)
      .then((res) => res);
  },
  PLMPublish(data) {
    return request
      .post("/halo/api/app/v1/getCadForder", data)
      .then((res) => res);
  },

  PLMPublished(data) {
    return request.post("/drawingRelease", data).then((res) => res);
  },

  queryTiziPreviewUrl(fileId) {
    return request
      .post(`file/v1/api/file/previewFile?fileId=${fileId}&type=oss`)
      .then((res) => res);
  },

  tiziDwgStartQinglianghua(fileId) {
    return request
      .get(`/hardcover-file/kit-dwg-convert?fileId=${fileId}`)
      .then((res) => res);
  },

  queryFileFolderStatus(data) {
    return request.post("/query-merge-status", data).then((res) => res);
  },

  queryTree(data = {}, isLoginFree) {
    if (isLoginFree) {
      return request.post("/doc/share/list", data).then((res) => res);
    } else {
      // 自定义接口地址
      const newUrl = globalParams.get("url:/doc/list");
      if (isDef(newUrl)) {
        return request.post(`${newUrl}`, data);
      }
      return request.post("/doc/list", data).then((res) => res);
    }
  },
  // 个人文档-我的文档 列表
  querypersonalTree(data = {}) {
    return request.post("/personal/doc/list", data).then((res) => res);
  },
  // 分享资料-公共资料 列表
  queryenterpriseTree(data = {}) {
    return request.post("/enterprise/doc/list", data).then((res) => res);
  },

  newQueryTree(data = {}) {
    return request.post("/doc/getFolderOrFile", data).then((res) => res);
  },

  queryHyTree(prjId, folderId, type) {
    return request
      .get(
        `/ecm/getFolderList?prjId=${prjId}&folderId=${folderId}&type=${type}`
      )
      .then((res) => res);
  },
  // 个人文档-回收站
  querypersonalRecycle(enterpriseId, name) {
    return request
      .get(
        `/personal/doc/recycle/list?enterpriseId=${enterpriseId}&name=${name}`
      )
      .then((res) => res);
  },
  queryRecycle(prjId, name) {
    return request
      .get(`/doc/recycle/list?prjId=${prjId}&name=${name}`)
      .then((res) => res);
  },
  // 企业文档-回收站
  queryenterpriseRecycle(enterpriseId, name) {
    return request
      .get(
        `/enterprise/doc/recycle/list?enterpriseId=${enterpriseId}&name=${name}`
      )
      .then((res) => res);
  },
  queryAddFolder(data = {}) {
    return request.post("/doc/newFolder", data).then((res) => res);
  },
  // 个人文档新建文件夹
  querypersonalAddFolder(data = {}) {
    return request.post("/personal/doc/newFolder", data).then((res) => res);
  },
  // 分享资料/公共资料新建文件夹
  queryenterpriseAddFolder(data = {}) {
    return request.post("/enterprise/doc/newFolder", data).then((res) => res);
  },

  queryDeleteFile(data) {
    return request.post("/doc/delete", data).then((res) => res);
  },

  // 供方仿真模拟提资资料文件下载
  queryfangzhenmoniFileDownload(fileId, breakPointType) {
    return request
      .get(
        `/digitalLibrary/getDownloadUrl?fileId=${fileId}&breakPointType=${breakPointType}`
      )
      .then((res) => res);
  },

  delFangZhenFile(fileId) {
    return request
      .get(`/digitalLibrary/deleteResourceByFileId?fileId=${fileId}`)
      .then((res) => res);
  },

  queryRechristen(data = {}) {
    return request.post("/doc/rename", data).then((res) => res);
  },

  renameMyDoc(data = {}) {
    return request.post("/personal/doc/rename", data);
  },

  querySearchFolder(data = {}) {
    return request.post("/doc/query", data).then((res) => res);
  },

  queryCopy(folderID, parentID, prjID) {
    return request
      .post(`/doc/copy?ids=${folderID}&parentID=${parentID}&prjID=${prjID}`)
      .then((res) => res);
  },

  queryHyCopy(data = {}) {
    return request.post("/ecm/copyEcmFolder", data).then((res) => res);
  },

  queryMove(folderID, parentID) {
    return request
      .post(`/doc/move?ids=${folderID}&parentID=${parentID}`)
      .then((res) => res);
  },

  queryBaseProperty(folderID, isFolder, versionID) {
    return request
      .post(
        `/doc/queryDetail?id=${folderID}&isFolder=${isFolder}&versionID=${versionID}`
      )
      .then((res) => res);
  },

  queryLinkDoc(fileID) {
    return request.post("/doc/relevancy/query", fileID).then((res) => res);
  },

  addLinkDoc(data = {}) {
    return request.post("/doc/relevancy/add", data).then((res) => res);
  },

  deleteLinkDoc(relaID) {
    return request
      .post(`/doc/relevancy/delete?relaID=${relaID}`)
      .then((res) => res);
  },

  queryFolderAuth(folderID, userType) {
    return request
      .post(`/doc/privi-query?folderID=${folderID}&userType=${userType}`)
      .then((res) => res);
  },

  queryPerson(prjId) {
    return request
      .get(`//halo/api/app/v1/iamUserInfo/getUserInfoByPrjId?prjId=${prjId}`)
      .then((res) => res);
  },

  queryRole(prjId) {
    return request
      .get(`//halo/api/app/v1/iamUserInfo/getRoleNameByPrjId?prjId=${prjId}`)
      .then((res) => res);
  },

  addOrDelOrUpPersonOrRole(list) {
    return request.post("/doc/privi-operation", list).then((res) => res);
  },

  creatVersion(versionObj) {
    return request.post("/doc/edition", versionObj).then((res) => res);
  },
  creatProVersion(params) {
    return request.post("/doc/addStage", params);
  },

  updateVersionName(data) {
    return request.post("/doc/edition/update", data).then((res) => res);
  },

  interiorShare(data) {
    return request.post("/doc/internal-share", data).then((res) => res);
  },

  creatShareLink(data) {
    return request.post("/doc/genShareLink", data).then((res) => res);
  },

  queryVersions(folderID, prjID) {
    return request
      .get(`/doc/edition/query?folderID=${folderID}&prjID=${prjID}`)
      .then((res) => res);
  },

  confirmVersion(versionID) {
    return request
      .get(`/doc/edition/define?versionID=${versionID}`)
      .then((res) => res);
  },

  deleteVersion(versionID) {
    return request
      .post(`/doc/edition/delete?versionID=${versionID}`)
      .then((res) => res);
  },

  getoffice(fileId) {
    const url = viewOfficeUrl(fileId);
    return request.get(url).then((res) => res);
  },

  queryLocalOfficeUrl(fileId, prjId) {
    return request
      .get(`/wopi/preview/office?fileId=${fileId}&prjId=${prjId}`)
      .then((res) => res);
  },

  getRreadArr(data) {
    return request.post("/doc/navbar", data).then((res) => res);
  },

  fileMerge(data) {
    return request.post("/doc/mergeFile/fullAmount", data).then((res) => res);
  },

  archive(data) {
    return request.post("/doc/archive", data).then((res) => res);
  },
  // 浏览记录接口
  saveScanHistory(obj) {
    return request.post("/doc/file-oper/save", obj).then((res) => res);
  },

  addTemplate(data) {
    return request.post("/doc/add-folder-template", data).then((res) => res);
  },

  queryModelLinkDoc(data) {
    return request.post("/doc/model/relevancy/query", data).then((res) => res);
  },

  deleteModelLinkDoc(relaID) {
    return request
      .post(`/doc/model/relevancy/delete?relaID=${relaID}`)
      .then((res) => res);
  },

  addModelLinkDoc(data) {
    return request.post("/doc/model/relevancy/add", data).then((res) => res);
  },

  isArchiveFile(fileId) {
    return request
      .get(`/doc/archive/get-file-real/${fileId}`)
      .then((res) => res);
  },

  // 模型关联文件预览,根据fileid,prjid查询最新的versionId,versionName
  queryNewVersionIdAndVersionName(prjId, fileId) {
    return request
      .get(`/doc/get-docVersion-byFileId?prjId=${prjId}&fileId=${fileId}`)
      .then((res) => res);
  },

  // 调用接口判断当前用户是否有归档/创建版本/确认版本的权限
  queryIsArchiveVersionAuth(prjId, folderId) {
    return request
      .get(`/doc/get-docPermission?prjId=${prjId}&folderId=${folderId}`)
      .then((res) => res);
  },

  recycleDeleteAndRestore(data = {}) {
    return request.post("/doc/recycle/update", data).then((res) => res);
  },
  recycldelete(data = {}) {
    return request.post("/doc/recycle/delete", data).then((res) => res);
  },
  recyclerestore(data = {}) {
    return request.post("/doc/recycle/restore", data).then((res) => res);
  },
  queryCADFolderID(prjID, folderId) {
    return request
      .get(`/doc/query-id-by-oldid?prjID=${prjID}&folderId=${folderId}`)
      .then((res) => res);
  },

  docCreatLFCFile(data = {}) {
    return request
      .post("/halo/api/app/v1/generateLfcFile", data)
      .then((res) => res);
  },

  rvtFileProperty(fileId) {
    return request
      .post(`/halo/api/app/v1/updateFileAttribute?fileId=${fileId}`)
      .then((res) => res);
  },

  queryFileIsSubmit(data) {
    return request.post("/doc/getVersionLock", data).then((res) => res);
  },

  queryToken() {
    return request.get(`/halo/api/app/v1/query/token`).then((res) => res);
  },

  queryMyShareToken(shareID) {
    return request
      .post(`/doc/createShareToken?shareID=${shareID}`)
      .then((res) => res);
  },

  addOperationLog(data = {}) {
    return request.post("/doc/add-folderOperHis", data);
  },

  queryIsInitFolder(prjID, folderId) {
    return request.get(
      `/doc/query-id-by-oldid?prjID=${prjID}&folderId=${folderId}`
    );
  },

  queryQuestionNumber(data) {
    return request.post(
      `/halo/api/app-doc-center/v1/problem/manage/query-file-question-number`,
      data
    );
  },

  queryOfficeStatus(folderID) {
    return request.get(
      `/halo/api/app-doc-center/v1/doc/queryFileDetail?id=${folderID}`
    );
  },

  addFavorite(data) {
    return request.post(`/doc/addFavorite`, data);
  },
  deleteFavorite(data) {
    return request.post(`/doc/deleteFavorite`, data);
  },
  queryFavorite(pageNo, pageSize) {
    return request.get(
      `/doc/queryFavorite?pageNo=${pageNo}&pageSize=${pageSize}`
    );
  },
  queryCollaborativeDocUrl(prjID) {
    return request.get(`/doc/getShimoFolderUrl?spaceId=${prjID}`);
  },
  getFolderPrivi(data) {
    return request.post("/doc/getFolderPrivi", data);
  },
  getShareQueryList(data) {
    return request.post("/doc/share/queryList", data);
  },
  getprjinfol(prjID) {
    return request.get(`/prj-home/get-prj-info?prjId=${prjID}`);
  },
  batchReConvert(data) {
    return request.post("/batchReConvert", data);
  },
  navbar(isFolder, id) {
    return request.get(`/doc/navbar/${isFolder}/${id}`).then((res) => res);
  },
  downloadfolder(params1) {
    return request({
      responseType: "blob",
      url: "/doc/share/download/folder",
      method: "post",
      data: params1
    });
  },
  lightuploadLightFile(params) {
    return request.post(`/light/uploadLightFile`, params).then((res) => res);
  },
  integrationModel(params) {
    return request.post(`/integrationModel/add`, params).then((res) => res);
  },
  getQueryList(prjID) {
    return request
      .get(`/integrationModel/queryList?prjId=${prjID}`)
      .then((res) => res);
  },
  batchDelete(params) {
    return request.post(`/integrationModel/batchDelete`, params);
  },
  // 文档移动
  docMove(params) {
    return request.post(`/doc/move`, params);
  },
  // 文档移动
  docCopy(params) {
    return request.post(`/doc/copy`, params);
  },

  // 流程本地上传获取文件夹id
  getFolderIdByOldId(prjId, oldId) {
    return request.get(`/doc/getFolderIdByOldId?prjId=${prjId}&oldId=${oldId}`);
  },
  // 分页查询整合模型记录
  queryIntegrationModelLogPage(params) {
    return request.get(
      `/integrationModel/queryIntegrationModelLogPage?${qs.stringify(params)}`
    );
  },
  // 添加整合模型记录
  addIntegrationModelLog(params) {
    // 自定义接口地址
    const newUrl = globalParams.get("url:/integrationModel/addIntegrationModelLog");
    if (isDef(newUrl)) {
      return request.post(`${newUrl}`, params);
    }
    return request.post(`/integrationModel/addIntegrationModelLog`, params);
  },
  // 批量删除整合模型记录
  batchIntegrationModelLog(params) {
    return request.post(`/integrationModel/batchIntegrationModelLog`, params);
  },
  // 文件详情
  getFileDetails(fileId) {
    return request.get(`/file/getFileDetails?fileId=${fileId}`);
  },

  // 项目公告和系统公告上传文件 获取隐藏文件夹id
  docGetFolderId(params) {
    return request.post(`/doc/getFolderId`, params);
  },

  queryPrjName(prjId) {
    return request.get(`/project/queryName?prjId=` + prjId).then(res => res.data || "");
  }
};
